import { Tab, Tabs } from '@lmig/lmds-react-tabs';
import { useEffect, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import './L2NavigationStandard.scss';

interface L2NavigationCustomLink {
    Goal: string;
    SubText: string | null;
    Id: string;
    Anchor: string;
    Class: string;
    Text: string;
    Query: string;
    Title: string;
    Url: string;
    Target: string;
    TargetId: string;
    Type: number;
    Style: string;
}

interface L2NavigationLink {
    Anchor: string;
    Class: string;
    Text: string;
    Query: string;
    Title: string;
    Url: string;
    Target: string;
    TargetId: string;
    Type: number;
    Style: string;
    SubLinks: L2NavigationLink[];
    HasChildren: boolean;
    IsActive: boolean;
    CustomLink: L2NavigationCustomLink;
    SortOrder: number;
}

interface L2NavigationLinkWrapper {
    Link: L2NavigationLink | null | undefined;
    SubLinks: L2NavigationLink[] | null | undefined | string[]; // may not need?
    HasChildren: boolean | null | undefined; // may not need?
    IsActive: boolean | null | undefined; // may not need?
    CustomLink: L2NavigationCustomLink | null | undefined; // may not need?
    SortOrder: number | null | undefined; // may not need?
}

interface L2NavigationStandardProps {
    links: L2NavigationLinkWrapper[] | null | undefined;
}
    
const L2NavigationStandard = (props: L2NavigationStandardProps) => {
    const [activeTab, setActiveTab] = useState<number | undefined>(undefined);

    const navigateToPage = (url?: string) => {
        if (!url) {
            return;
        }

        const targetUrl = new URL(url, window.location.origin);
        const currentParams = new URLSearchParams(window.location.search);
        const targetParams = new URLSearchParams(targetUrl.search);

        currentParams.forEach((value, key) => {
            if (!targetParams.has(key)) {
                targetParams.append(key, value);
            }
        });

        targetUrl.search = targetParams.toString();
        window.location.assign(targetUrl.toString());
    };

    useEffect(() => {
        if (!props?.links || !Array.isArray(props.links)) {
            return;
        }

        const activeIndex = (() => {
            for (let index = 0; index < props.links.length; index++) {
                if (props.links[index]?.IsActive) {
                    return index;
                }
            }
            return 0;
        })();

        if (activeIndex >= 0 && activeIndex !== activeTab) {
            setActiveTab(activeIndex);
        }
    }, [props.links, activeTab]);

    return (
        <ErrorBoundary key={activeTab} fallback={
            <div style={{ display: 'none' }}>{`ERROR in L2NavigationStandard: activeTab=${activeTab}`}</div>
        }>
            <div>
                {props.links && Array.isArray(props.links) &&
                    <Tabs
                        activeTab={activeTab}
                        onTabActivated={(event, index) => {
                            navigateToPage(props?.links?.[index]?.Link?.Url);
                        }}
                    >
                        {props.links.map((link, index) => (
                            link?.Link &&
                                <Tab
                                    key={index}
                                    labelVisual={link.Link?.Text}
                                    onClick={() => navigateToPage(link.Link?.Url)}
                                >
                                    <>{/* children required for the component, but no body content needed */}</>
                                </Tab>
                        ))}
                    </Tabs>
                }
            </div>
        </ErrorBoundary>
    );
};

export default L2NavigationStandard;